import './StyleGuide.css';
import React from 'react'
import { useState } from 'react'

function ErrorGuide() {

    const [error, setError] = useState(false);

    const display_error = (e) => {
        if(error){
            setError(false)
        }else{
            setError(true)
        }
    }

    if(!error){
        return (
            <div id="elements">
                <h2 className="style_header">Error Handling</h2>
                <div className='errors'>
                        <p className='medium'>One way our application handles errors is by displaying them to the user. </p>
                        <p className='medium'>For Example, when registering or signing in, if the user performs something incorrectly, 
                        like specifying an invalid email, a red message should appear where they can clearly see.</p>
                        <p className='medium'>The message should be short, but also specific enough to allow the user to fix the error if possible.</p>
                <div className='button2'>
                    <button type="button" className="sign_button" onClick={display_error}>Click for Error Message!</button>
                </div>
                <div>
                    <p className='medium'> For the error message, the color should be red to indicate an error and the font-weight should be normal so it is not irritating.</p>
                </div>
            </div>
        </div>
        )
    }else{
        return (
                <div id="elements">
                    <h2 className="style_header">Error Handling</h2>
                    <div className='errors'>
                        <p className='medium'>One way our application handles errors is by displaying them to the user. </p>
                        <p className='medium'>For Example, when registering or signing in, if the user performs something incorrectly, 
                        like specifying an invalid email, a red message should appear where they can clearly see.</p>
                        <p className='medium'>The message should be short, but also specific enough to allow the user to fix the error if possible.</p>
                <div className='button2'>
                    <button type="button" className="sign_button" onClick={display_error}>Click for Error Message!</button>
                </div>
                <div className='error_msg'>Click the button to fix this :)</div>
                <div>
                    <p className='medium'> For the error message, the color should be red to indicate an error and the font-weight should be normal so it is not irritating.</p>
                </div>
                </div> 
            </div>
        )
    }
}

export default ErrorGuide
